interface IconProps {
  colour: string;
}

const Icon = ({ colour, ...props }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="37" viewBox="0 0 35 37" {...props}>
    <path
      fill={colour}
      fillRule="evenodd"
      d="M25.312 3.687C31.05 6.559 35 12.476 35 19.33c0 9.665-7.835 17.5-17.5 17.5-9.666 0-17.5-7.835-17.5-17.5C0 12.476 3.95 6.559 9.687 3.687c-.37.853-.6 1.778-.67 2.747-4.19 2.762-6.959 7.503-6.959 12.896 0 4.263 1.729 8.124 4.524 10.919 2.794 2.793 6.655-.625 10.918-.625 4.264 0 8.125 3.418 10.919.625a15.397 15.397 0 004.522-10.92c0-5.392-2.768-10.133-6.958-12.895a8.434 8.434 0 00-.671-2.747zm-2.55 8.762c4.407 0 5.5 5.11 5.5 9.533 0 2.456-1.614 4.456-3.581 4.456H10.32c-1.968 0-3.582-2-3.582-4.456 0-4.422 1.094-9.533 5.5-9.533A7.507 7.507 0 0017.5 14.6a7.505 7.505 0 005.262-2.151zM17.5.61a6.458 6.458 0 010 12.914 6.459 6.459 0 01-6.457-6.457A6.458 6.458 0 0117.5.61z"
    ></path>
  </svg>
);

export default Icon;
